import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './ServiceDetail.css';

import yoga4 from "../assets/images/homenew.jpeg";
import yoga5 from "../assets/images/onlineyoga.png";
import yoga10 from "../assets/images/studio.jpeg";
import pregnancy from "../assets/images/corprate.jpeg";
import urja from "../assets/images/pregnent.jpeg";
import e1 from "../assets/images/pregnency.png";
import e2 from "../assets/images/positive.jpeg";
import e3 from "../assets/images/stress.jpeg";

const services = {
  'yoga-at-your-home': {
    title: 'Yoga at Your Home',
    image: yoga4,
    content: [
      'Practicing yoga at home can create a peaceful and familiar environment where people feel more relaxed and focused. At Yoga Karega India, we provide guided yoga sessions that can be practiced directly from your home, allowing you to build a wellness routine without needing to travel to a studio. Many people find that practicing yoga in their own space helps them stay consistent and comfortable.',
      'Our sessions are guided by experienced and certified yoga trainers who carefully explain each posture and encourage participants to practice with awareness and patience. Everyone has a different level of flexibility and experience, and our trainers understand the importance of adapting the practice accordingly. Home yoga sessions provide a convenient and supportive way for individuals and families in India to include yoga as a regular part of their lifestyle.'
    ]
  },
  'online-yoga': {
    title: 'Online Yoga',
    image: yoga5,
    content: [
      'At Yoga Karega India, we believe that yoga should be available to everyone, no matter where they are located. Many people today have busy routines, long working hours, or limited access to nearby yoga centers. Our online yoga sessions are designed to remove those barriers and make yoga more accessible for people across India. By joining online, participants can practice comfortably from their own homes while still receiving clear guidance from experienced and certified yoga trainers.',
      'Our trainers focus on explaining each posture, breathing technique, and movement in a simple and understandable way so that participants feel confident while learning. The sessions are structured to allow people to move at a comfortable pace without feeling rushed or pressured. Many participants appreciate the flexibility of online yoga because it allows them to take care of their wellbeing while balancing work, studies, and family life. With regular practice, online yoga can become a convenient and meaningful part of a healthy daily routine.'
    ]
  },
  'yoga-studio': {
    title: 'Yoga Studio',
    image: yoga10,
    content: [
      'At Yoga Karega India, our yoga studio sessions are designed to provide a calm and focused environment where people can learn and practice yoga with proper guidance. A dedicated yoga space often helps participants feel more connected to the practice, as the surroundings are created to support relaxation, concentration, and mindful movement. In the studio, participants can practice alongside others who share the same interest in improving their health and wellbeing, which often creates a motivating and positive atmosphere.',
      'Our sessions are guided by experienced and certified yoga trainers who carefully explain each posture, breathing technique, and movement step by step. The aim is to help participants understand yoga in a safe and comfortable way while developing confidence in their practice. Whether someone is new to yoga or already familiar with it, the studio sessions are structured so that everyone can participate at their own pace and gradually improve their flexibility, strength, and awareness.',
      'At Yoga Karega India, we are committed to making yoga accessible to people across the country. Along with studio sessions, our services are available across India, allowing individuals, families, and communities in different cities to connect with our yoga programs. Our goal is to create opportunities for people throughout India to experience the benefits of yoga through guided practice, supportive instruction, and a welcoming environment.',
      'Through consistent practice and proper guidance, many people find that yoga becomes more than just a physical activity — it becomes a meaningful part of their daily lifestyle and overall wellbeing.'
    ]
  },
  'corporate-yoga': {
    title: 'Corporate Yoga',
    image: pregnancy,
    content: [
      'Every individual\'s body is unique, and yoga should always be practiced with awareness and respect for personal limits. At Yoga Karega India, we follow a cooperative approach where the instructor and participants work together to create a safe and comfortable practice environment. Our experienced and certified yoga trainers carefully guide participants step by step so they can understand the purpose of each posture and movement.',
      'Rather than focusing on perfection, the emphasis is placed on gradual learning and consistent practice. Participants are encouraged to listen to their bodies and move at a pace that feels right for them. This cooperative and supportive approach allows people to build confidence in their yoga journey while feeling guided and supported at every step.'
    ]
  },
  'pregnancy-yoga': {
    title: 'Pregnancy Yoga',
    image: urja,
    content: [
      'Pregnancy is a special and important phase of life, and many women look for gentle ways to stay active and relaxed during this time. Pregnancy yoga focuses on light movements, breathing techniques, and relaxation practices that are commonly used to support comfort and wellbeing during pregnancy. At Yoga Karega India, these sessions are conducted with care and awareness so that expecting mothers can practice in a calm and supportive environment.',
      'Our trained and certified yoga instructors guide participants with simple and gentle practices that focus on breathing, body awareness, and relaxation. Many women appreciate having a peaceful space where they can take time for themselves and focus on their physical and emotional wellbeing during pregnancy. With proper guidance and awareness, pregnancy yoga can be a gentle and supportive practice throughout this stage of life.'
    ]
  },
  'meditation-magic': {
    title: 'Meditation Magic',
    image: e1,
    content: [
      'Meditation is a practice that encourages people to slow down and become more aware of their thoughts, breathing, and surroundings. In today\'s fast-moving lifestyle, many people feel mentally overwhelmed and look for simple ways to bring calmness into their daily routine. Meditation offers an opportunity to pause, relax, and reconnect with the present moment.',
      'At Yoga Karega India, meditation sessions are guided by experienced yoga trainers who introduce simple and practical techniques suitable for beginners as well as regular practitioners. Participants are guided to focus on their breathing and gradually develop awareness and inner calm. Many people across India are rediscovering meditation as a way to create balance between mental activity and inner peace. With regular practice, meditation can become a meaningful habit that supports clarity, focus, and emotional wellbeing.'
    ]
  },
  'positive-instruction': {
    title: 'Positive Interaction',
    image: e2,
    content: [
      'A positive and welcoming environment plays an important role in making yoga enjoyable and comfortable for everyone. At Yoga Karega India, we aim to create sessions where participants feel respected, supported, and encouraged throughout their practice. Our certified yoga trainers guide the sessions patiently and make sure that participants feel comfortable asking questions or seeking clarification.',
      'This positive interaction helps build trust between the instructor and participants, which can make the learning process more relaxed and enjoyable. When people feel supported and understood, they are more likely to stay motivated and continue practicing regularly. Yoga then becomes not only a physical activity but also a space where individuals can feel encouraged and connected in a healthy and positive way.'
    ]
  },
  'stress-relief': {
    title: 'Stress Relief',
    image: e3,
    content: [
      'Modern life often comes with many responsibilities and pressures, whether it is related to work, studies, or personal commitments. Because of this, many people look for healthy ways to relax and create balance in their lives. Yoga practices such as breathing exercises, gentle stretching, and relaxation techniques are commonly used to help people slow down and reconnect with themselves.',
      'At Yoga Karega India, our experienced yoga trainers guide participants through practices that encourage calmness and mindfulness. The sessions are designed to help people take a break from daily stress and focus on their breathing and body awareness. Many individuals who practice yoga regularly feel that it helps them maintain a more balanced lifestyle and approach their daily responsibilities with a calmer mindset. While each person\'s experience may be different, yoga is widely appreciated as a supportive practice for overall wellbeing.'
    ]
  }
};

function ServiceDetail() {
  const { slug } = useParams();
  const service = services[slug];

  if (!service) {
    return (
      <div className="service-detail-not-found">
        <h2>Service not found</h2>
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
    );
  }

  return (
    <div className="service-detail-page">
      {/* Hero Banner */}
      <div className="service-detail-hero">
        <img src={service.image} alt={service.title} className="service-detail-hero-img" />
        <div className="service-detail-hero-overlay">
          <div className="service-detail-hero-content">
            <span className="service-detail-tag">Our Services</span>
            <h1 className="service-detail-title">{service.title}</h1>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="service-detail-body">
        <div className="service-detail-container">
          <Link to="/" className="service-detail-back">
            ← Back to Home
          </Link>

          <div className="service-detail-content">
            <div className="service-detail-text-section">
              {service.content.map((para, index) => (
                <p key={index} className="service-detail-paragraph">{para}</p>
              ))}
            </div>

            {/* CTA */}
            <div className="service-detail-cta">
              <h3>Ready to start your yoga journey?</h3>
              <p>Connect with our certified trainers and begin your path to wellness today.</p>
              <div className="service-detail-cta-buttons">
                <a href="tel:+919370832534" className="service-cta-btn primary">
                  📞 Call Now
                </a>
                <Link to="/booking" className="service-cta-btn outline">
                  Book a Session
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceDetail;
